export const scrollToConf = {
  top: 0,
  behavior: 'smooth' as ScrollBehavior,
};
